import { isDevelopmentEnvironment } from '@alexis/helpers/environment';

export async function register(): Promise<void> {
  // Skip service worker registration in development environment
  if (isDevelopmentEnvironment(window.location.hostname)) {
    console.log('🚫 Service worker registration skipped in development environment');
    return;
  }

  if ('serviceWorker' in navigator) {
    const { Workbox } = await import('workbox-window');

    const wb = new Workbox('/roxana-service-worker.js');

    const showSkipWaitingPrompt = async () => {
      wb.addEventListener('controlling', () => {
        window.location.reload();
      });

      wb.messageSkipWaiting();
    };

    wb.addEventListener('waiting', () => {
      showSkipWaitingPrompt();
    });

    await wb.register();
    document.dispatchEvent(new CustomEvent('registerServiceWorker'));
  }
}
